
import DirectionsIcon from '../../../_globals/vectors/DirectionsIcon.vue'

export default {
  name: 'LocationAddressInfo',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
  },
  components: {
    DirectionsIcon,
  },
}
